import { trackCustomPageView } from "./pagetracking";

/**
 * Initialize digitalData object structure
 */
export const initializeDigitalData = (): void => {
  if (!globalThis.digitalData) {
    globalThis.digitalData = {};
  }

  globalThis.digitalData.page = globalThis.digitalData.page || {};
  globalThis.digitalData.user = globalThis.digitalData.user || {};
  globalThis.digitalData.site = globalThis.digitalData.site || {};
  globalThis.digitalData.event = globalThis.digitalData.event || {};
};

/**
 * Update page information
 */
export const setPageInfo = (
  pageName: string,
  pageData?: {
    pageTemplate?: string;
    pageType?: string;
    contentTitle?: string;
    contentType?: string;
  },
): void => {
  if (!globalThis.digitalData) initializeDigitalData();

  globalThis.digitalData!.page = {
    ...globalThis.digitalData!.page,
    pageInfo: {
      page: pageName,
      pageNameGranular: pageName,
      pageName: pageName.split(":").pop() || pageName,
      pageTemplate: pageData?.pageTemplate || "",
      pageType: pageData?.pageType || "",
      previousPage: sessionStorage.getItem("previousPage") || "",
      previousLink: document.referrer,
      ...pageData,
    },
  };

  // Update previous page
  sessionStorage.setItem("previousPage", pageName);

  console.log("📄 Page Info Updated:", globalThis.digitalData!.page.pageInfo);
  globalThis.digitalData?.page?.pageInfo?.page ===
    "kporg:en:nat:mykp:wfr:home:tuition:start" && trackCustomPageView("start");
};

/**
 * Update user information from Redux/Auth
 */
export const setUserInfo = (userData: {
  nuid?: string;
  email?: string;
  region?: string;
  loginState?: "Authenticated" | "Unauthenticated";
  userType?: string;
  jobRole?: string;
  employeeTenure?: string;
  union?: string;
  workforceClass?: string;
}): void => {
  if (!globalThis.digitalData) initializeDigitalData();

  globalThis.digitalData!.user = {
    ...globalThis.digitalData!.user,
    userID: userData.nuid || "",
    loginState: userData.loginState || "Unauthenticated",
    profile: {
      region: userData.region || "",
    },
    job: {
      jobRole: userData.jobRole || "",
    },
    employee: {
      union: userData.union || "",
      workforceClass: userData.workforceClass || "",
      employeeTenure: userData.employeeTenure || "",
    },
    timestamp: new Date().toISOString(),
    userKnown: !!userData.nuid,
  };

  console.log("👤 User Info Updated:", globalThis.digitalData!.user);
};

/**
 * Set site information
 */
export const setSiteInfo = (app: "citizenship" | "tuition"): void => {
  if (!globalThis.digitalData) initializeDigitalData();

  globalThis.digitalData!.site = {
    siteName: "kporg",
    domain: "kp",
    subdomain: "mykp",
    language: "en",
    charSet: "UTF-8",
    applicationName: app,
  };

  console.log("🌐 Site Info Updated:", globalThis.digitalData!.site);
};

/**
 * Set form/page content information
 */
export const setContentInfo = (contentData: {
  title?: string;
  type?: string;
  author?: string;
  publishDate?: string;
  modificationDate?: string;
  tags?: string;
}): void => {
  if (!globalThis.digitalData) initializeDigitalData();

  globalThis.digitalData!.page = {
    ...globalThis.digitalData!.page,
    content: {
      title: contentData.title || "",
      type: contentData.type || "form",
      author: contentData.author || "",
      source: "",
      contentID: "",
      contentView: "",
      owner: "",
      contentPublishDate: contentData.publishDate || "",
      contentModificationDate: contentData.modificationDate || "",
      contentTags: contentData.tags?.replaceAll(',', "|") || "",
      contentTopic: "",
      contentDaysSincePublish: "",
    },
  };

  console.log("📝 Content Info Updated:", globalThis.digitalData!.page.content);
};

/**
 * Get current digitalData
 */
export const getDigitalData = (): any => {
  return globalThis.digitalData || {};
};

/**
 * Log digitalData for debugging
 */
export const logDigitalData = (): void => {
  console.group("📊 Digital Data");
  console.groupEnd();
};
